<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="title"
      :close-on-click-modal="false"
      width="1000px"
      :before-close="cancel"
      append-to-body
      class="app-main-inner special-charge-window"
    >
      <div class="app-main-inner-row">
        <el-form label-position="left" label-width="90px" :model="adjustCharge">
          <!-- 字段按需求表格：所属分公司/费用名称/结算对象/开票抬头/单位/数量/单价/汇率/币种/是否需要开票/国内国外/含税价/不含税价/税额/税率/备注 -->
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ChargeBranchId')">
                <!-- 商务特殊费用：所属分公司只读，默认订单所属分公司 -->
                <el-input :value="branchOfficeName" disabled style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ChargeItem')">
                <cargo-advance-select
                  filterable
                  :method-params="getChargeItemFilter()"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :default-value="Number(adjustCharge.chargeItemId) || ''"
                  options-width="250px"
                  tag-value="itemId"
                  tag-name="zhName"
                  :disabled="!isEditing"
                  @parentCallBack="onChangeCompany"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.AccountObject')">
                <!-- 结算对象取值范围同普通应付费用新增（tabChargesHP 应付结算对象列）：启用公司中的供应商，不限本分公司 -->
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="Number(adjustCharge.accountId) || ''"
                  :method-params="{ active: true }"
                  :receivable="false"
                  auto-key="auto_accountId"
                  :data-filter-function="apAccountFilter"
                  options-width="200px;"
                  :disabled="!isEditing"
                  tag-name="chineseName"
                  @parentCallBack="textAccountCode_changeHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('FinanceManage.charge_invoiceHeader')">
                <cargo-advance-select
                  :filterable="true"
                  filter-type="global"
                  :allow-create="!settlementUnitOptional"
                  :default-value="adjustCharge.invoiceTitle"
                  :disabled="!isEditing"
                  options-width="200px;"
                  tag-value="title"
                  tag-name="title"
                  :filter-tag-names="['title']"
                  :static-options="invoiceTitleList"
                  @parentCallBack="textInvoiceTitleChangeHandle"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Unit')">
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_ChargeMeasure"
                  filterable
                  :clearable="false"
                  options-width="100px"
                  :disabled="!isEditing"
                  :method-params="{seaFreight: true}"
                  :default-value="adjustCharge.measure || ''"
                  @parentCallBack="combMeasureChangeHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Quantity2')">
                <el-input-number v-model="adjustCharge.quantity" :max="999999999" :min="-999999999" style="width: 100%;" :precision="3" :controls="false" :disabled="!isEditing" @change="txtQuantityChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.UnitRate')">
                <el-input-number v-model="adjustCharge.unitRate" :max="999999999" :min="-999999999" style="width: 100%;" :precision="3" :controls="false" :disabled="!isEditing" @change="txtUnitRateChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.ExchangeRate')">
                <num-input
                  v-model="adjustCharge.exchangeRate"
                  :precision="8"
                  :truncated-precision="exchangeRatePrecision"
                  :max="999999999"
                  :min="-999999999"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Currency')">
                <cargo-advance-select
                  filterable
                  :clearable="false"
                  :select-type="selectTypeNames.basic_data_Currency"
                  :default-value="adjustCharge.currency || ''"
                  options-width="100px"
                  :disabled="!isEditing"
                  @parentCallBack="textCurrencyChangeHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.IsNeedInvoice')">
                <cargo-advance-select
                  filterable
                  :clearable="false"
                  :fields="['value']"
                  :callback-params="{key:'needInvoice'}"
                  callback-method-type="value"
                  :default-value="adjustCharge.needInvoice"
                  :cache="false"
                  tag-value="code"
                  tag-name="value"
                  options-width="100px"
                  :disabled="!isEditing"
                  :static-options="[{code:false,value:$t('CargoMsg.Cargo_No')},{code:true,value:$t('CargoMsg.Cargo_Yes')}]"
                  :filter-tag-names="['value']"
                  @parentCallBack="item=>adjustCharge.needInvoice=item.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Oversea')" style="width: 100%">
                <cargo-advance-select
                  filterable
                  :clearable="false"
                  :fields="['value']"
                  :callback-params="{key:'oversea'}"
                  callback-method-type="value"
                  :default-value="String(adjustCharge.oversea)"
                  :cache="false"
                  tag-value="code"
                  tag-name="value"
                  style="width: 100%;"
                  :disabled="!isEditing"
                  :static-options="[{code:'false',value:$t('CargoMsg.Cargo_Domestic')},{code:'true',value:$t('CargoMsg.Cargo_International')}]"
                  :filter-tag-names="['value']"
                  options-width="150px"
                  @parentCallBack="onChangeIsOverseaHandler"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.IncludingTaxAmount')">
                <el-input-number v-model="adjustCharge.amount" :max="999999999" :min="-999999999" style="width: 100%;" :precision="2" :controls="false" :disabled="!isEditing" @change="textAmountChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.ExcludingTaxAmount')">
                <el-input-number :max="999999999" :min="-999999999" style="width: 100%" :value="!needInvoiceNo ? adjustCharge.excludingTaxAmount : adjustCharge.amount" :disabled="!isEditing" :precision="2" :controls="false" @input="val=>{adjustCharge.excludingTaxAmount=val}" @change="excludingTaxAmountChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.BillAmount')">
                <el-input-number v-model="adjustCharge.taxAmount" :max="999999999" :min="-999999999" style="width: 100%;" :precision="2" :controls="false" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.TaxRate')">
                <el-input-number :max="999999999" :min="-999999999" style="width: 100%;" :value="isNaN(adjustCharge.taxRate) ? '0' : adjustCharge.taxRate" :precision="2" :controls="false" :disabled="!isEditing" @input="val=>{adjustCharge.taxRate=val}" @change="txtRateChangeHandler" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$t('SeaExport.Remarks')">
                <el-input v-model="adjustCharge.remarks" type="textarea" :rows="5" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="saveEvent">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button size="mini" @click="cancel">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { getContacts } from '@/api/partner/contact'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import { Charge } from '@/class/model/act/Charge'
import { saveAdjustJob } from '@/api/booking/job'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { deepClone } from '@/utils'
import { getLoading } from '@/utils/utilBaseElement'
import moment from 'moment'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { queryTitleByCpmIdx } from '@/api/partner/title'

export default {
  name: 'BusinessSpecialChargeWindow',
  components: { CargoAdvanceSelect, NumInput },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    defaultProperties: { type: Object, required: true }, // 弹框打开时默认传递条件
    location: { type: String, required: false }
  },
  data() {
    return {
      userId: 0,
      pageDate: new Date(),
      officeId: 0,
      departmentId: 0,
      privilege: {
        isControlled: this.$checkPermission(['button_Charge_controlled']), // 是否有应付受控费用权限
        isCostControlled: this.$checkPermission(['button_Charge_costControlled']) // 是否有应收受控费用权限
      },
      profitOwner: '', // 利润所属方
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      rowData: [],
      title: '新增特殊费用',
      isEditing: true, // 默认不能编辑
      contactArray: [],
      officeList: [],
      invoiceTitleList: [],
      settlementUnitOptional: false,
      isAdjust: true, // 是否调整 借用[改单费用界面]的现有逻辑
      editMode: null, // 调整模式【新增/修改/删除 add/edit/del】
      isAdvance: false, //
      isAr: false,
      job: null,
      selectedJobs: [],
      charge: false,
      companyTitle: null,
      costCharge: null,
      adjustCharge: {}, // 调整的费用
      needInvoiceNo: false,
      needMakeInvoice: true, // 是否显示是否开票
      selCurrency: false,
      defaultDate: new Date(),
      isSpecialExpenseEntryFunction: false,
      chargeWeightValueType: 0
    }
  },
  computed: {
    exchangeRatePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(this.adjustCharge.currency)
    },
    // 商务特殊费用：所属分公司只读显示（默认订单所属分公司）
    branchOfficeName() {
      const branchId = Number(this.adjustCharge.branchId)
      if (!branchId || !this.officeList || this.officeList.length === 0) return ''
      const office = this.officeList.find(item => Number(item.officeId) === branchId)
      return office ? (office.chineseName || office.officeName || String(branchId)) : String(branchId)
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.defaultDate = moment(new Date()).format('yyyy-MM-DD')
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.userId = this.$store.getters.userId
    this.officeId = this.$store.getters.currentOfficeId
    this.departmentId = this.$store.getters.currentDeptId
    if (this.visible) {
      this.innerVisible = true
      this.onShow()
    }
  },
  beforeMount() {},
  methods: {
    // 初始化权限及配置参数
    async initializeHandler() {
      this.$logger.log('defaultProperties', this.defaultProperties)
      await cache.load(cacheName.CONFIG)
      const defaultProperties = this.defaultProperties
      if (this.defaultProperties) {
        // 初始化本界面需要的属性
        this.editMode = Object.prototype.hasOwnProperty.call(defaultProperties, 'editMode') ? defaultProperties['editMode'] : this.editMode
        this.isAdjust = Object.prototype.hasOwnProperty.call(defaultProperties, 'isAdjust') ? defaultProperties['isAdjust'] : this.isAdjust // 是否调整
        this.isAdvance = Object.prototype.hasOwnProperty.call(defaultProperties, 'isAdvance') ? defaultProperties['isAdvance'] : this.isAdvance
        this.needMakeInvoice = Object.prototype.hasOwnProperty.call(defaultProperties, 'needMakeInvoice') ? defaultProperties['needMakeInvoice'] : this.needMakeInvoice
        this.isAr = Object.prototype.hasOwnProperty.call(defaultProperties, 'isAr') ? defaultProperties['isAr'] : this.isAr
        this.job = Object.prototype.hasOwnProperty.call(defaultProperties, 'job') ? defaultProperties['job'] : this.job
        this.selectedJobs = Object.prototype.hasOwnProperty.call(defaultProperties, 'selectedJobs') ? defaultProperties['selectedJobs'] : this.selectedJobs
        this.charge = Object.prototype.hasOwnProperty.call(defaultProperties, 'charge') ? defaultProperties['charge'] : this.charge
        this.needInvoiceNo = Object.prototype.hasOwnProperty.call(defaultProperties, 'needInvoiceNo') ? defaultProperties['needInvoiceNo'] : this.needInvoiceNo
        // 删除调整 不能编辑，新增、修改可以
        this.isEditing = this.editMode && this.editMode !== 'del'
      }
      this.chargeWeightValueType = ChargeUtils.getChargeWeightValueType(true)
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
      this.settlementUnitOptional = String(cache.config.get('ToExoSystem')) === 'HC'
      const job = new Job(this.job)
      if (job) {
        // 加载数据
        job.charges = null
        await Promise.all([
          job.getSeaEQ(),
          job.getCharges(),
          job.getCargoDoc()
        ])
        if (job.planner && Number(job.planner) > 0) {
          const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', parseInt(job.planner))
          this.profitOwner = user.chineseName || ''
        }
      }
    },
    async onShow() {
      await cache.load(cacheName.OFFICE_LIST).then(() => {
        this.officeList = cache.officeList
      })
      this.invoiceTitleList = []
      await this.initializeHandler()
      if (this.editMode) {
        //
        // 若非增加调整，则将数据库中的费用替换界面传过来的费用，避免界面传过来的费用对象不完整
        if (this.charge && this.editMode !== 'add' && this.job.charges && this.job.charges.length > 0) {
          for (const c of this.job.charges) {
            if (c.uuid === this.charge.uuid) {
              this.charge = c
              break
            }
          }
        }
        // 设置窗口标题
        if (this.editMode === 'add') {
          this.title = this.$t('Message.AddBusinessSpecialCharge')
          this.charge.receivable = false
          ChargeUtils.changeItemRate(this.charge) // 获取税率
        } else if (this.editMode === 'edit') {
          this.title = this.$t('Message.EditBusinessSpecialCharge')
        } else if (this.editMode === 'addSpecialUpdate') {
          this.title = this.$t('Message.AddSpecialUpdate')
          this.charge.receivable = false
          ChargeUtils.changeItemRate(this.charge) // 获取税率
        } else {
          this.title = this.$t('Message.DeleteAdjustment')
        }
      }
      // 浅拷贝费用对象
      this.adjustCharge = deepClone(this.charge)
      const adjustCharge = this.adjustCharge
      if (this.isAdjust && adjustCharge) {
        const localCurrency = RateUtil.localCurrencyByOfficeId(adjustCharge.branchId)
        if (this.editMode === 'add' || this.editMode === 'addSpecialUpdate') {
          const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, adjustCharge.currency, this.getRateDate(), adjustCharge.branchId)
          adjustCharge.exchangeRate = isNaN(exchangeRate) ? 0 : exchangeRate
        }
        // if (this.editMode === 'edit') {
        //   // CARGO-8241，修改调整费用，切换窗口，币种会变成RMB
        //   if (this.selCurrency) {
        //     adjustCharge.currency = this.selCurrency ? this.selCurrency : adjustCharge.currency
        //   }
        //   // 修改调整时，根据当前日期的月份取汇率，调整日期为当前天
        //   const exchangeRate1 = await RateUtil.getForeignExchangeRateSafely('RMB', adjustCharge.currency, new Date())
        //   adjustCharge.exchangeRate = isNaN(exchangeRate1) ? 0 : exchangeRate1
        // }

        // 给界面显示框初始化值
        this.$logger.log('adjustCharge', adjustCharge)
        const isInit = this.editMode && (this.editMode === 'edit' || this.editMode === 'del')
        // adjustCharge['branchId'] = adjustCharge['branchId']
        adjustCharge['accountId'] = isInit ? adjustCharge['accountId'] : ''
        // 录入日期
        if (adjustCharge.dateCreated) {
          adjustCharge['dateCreated'] = isInit ? adjustCharge['dateCreated'] : new Date()
        }
        if (adjustCharge.specialInputDate) {
          adjustCharge['specialInputDate'] = isInit ? adjustCharge['specialInputDate'] : new Date()
        }
        adjustCharge['contactPerson'] = isInit ? adjustCharge['contactPerson'] : ''
        const currency = adjustCharge['currency'] !== this.selCurrency ? adjustCharge['currency'] : this.selCurrency
        // 币种为空默认 RMB（编辑历史空币种数据兜底；新增走 localCurrency 不会为空）
        adjustCharge['currency'] = isInit ? (currency || RateUtil.STANDARD_COIN) : localCurrency
        adjustCharge['quantity'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['quantity'], 3) : 1.000
        adjustCharge['unitRate'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['unitRate'], 2) : 0.00
        adjustCharge['invoiceNo'] = isInit ? adjustCharge['invoiceNo'] : ''
        adjustCharge['chargeItemId'] = isInit ? adjustCharge['chargeItemId'] : ''
        const excludingTaxAmount = !this.needInvoiceNo ? NumberUtils.roundHalfUp(adjustCharge['excludingTaxAmount'], 2) : NumberUtils.roundHalfUp(adjustCharge['amount'], 2)
        adjustCharge['excludingTaxAmount'] = isInit ? excludingTaxAmount : 0.00
        adjustCharge['amount'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['amount'], 2) : 0.00
        adjustCharge['taxAmount'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['taxAmount'], 2) : 0.00
        if (this.pageDate !== adjustCharge['auditDate'] && this.editMode === 'addSpecialUpdate') {
          adjustCharge['auditDate'] = this.pageDate
          this.adjustCharge.specialInputDate = adjustCharge['auditDate']
        } else {
          adjustCharge['auditDate'] = new Date()
        }
        adjustCharge['remarks'] = isInit ? adjustCharge['remarks'] : ''
        adjustCharge['measure'] = isInit ? adjustCharge['measure'] : 'NML'
        adjustCharge['needInvoice'] = isInit ? adjustCharge['needInvoice'] : true
        adjustCharge['controlled'] = isInit ? adjustCharge['controlled'] : true
        adjustCharge['oversea'] = isInit ? adjustCharge['oversea'] : false
        if (adjustCharge['accountId']) {
          this.loadContacts(adjustCharge['accountId'])
        }
      }
      // 获取开票抬头列表并设置默认值
      await this.loadShowInvoiceTitle()
    },
    // 开票抬头变更处理函数
    textInvoiceTitleChangeHandle(result) {
      if (result) {
        this.adjustCharge.invoiceTitle = result.value || result.title
      }
    },
    async loadShowInvoiceTitle() {
      if (this.charge && this.charge.accountId) {
        const res = await queryTitleByCpmIdx(this.charge.accountId)
        let dbTitles = res.data
        if (!dbTitles) dbTitles = []
        if (dbTitles.length > 0) {
          this.invoiceTitleList = dbTitles
        }
        if (!this.adjustCharge.invoiceTitle) {
          if (dbTitles.length > 0) {
            // 优先选择默认开票抬头，如果没有默认的则选择第一个
            const defaultTitle = dbTitles.find(title => title.defaultTitle === true)
            const selectedTitle = defaultTitle || dbTitles[0]
            if (selectedTitle && selectedTitle.title) {
              this.adjustCharge.invoiceTitle = selectedTitle.title
            }
          } else {
            // 如果没有开票抬头数据，清空当前值
            this.adjustCharge.invoiceTitle = ''
            this.invoiceTitleList = []
          }
        }
      }
    },
    // 获取开票抬头列表
    async loadInvoiceTitle(accountId) {
      let dbTitles = []
      if (accountId) {
        const res = await queryTitleByCpmIdx(accountId)
        if (res.data && res.data.length > 0) {
          dbTitles = res.data
        }
      }
      if (dbTitles.length > 0) {
        this.invoiceTitleList = dbTitles
        // 优先选择默认开票抬头，如果没有默认的则选择第一个
        const defaultTitle = dbTitles.find(title => title.defaultTitle === true)
        const selectedTitle = defaultTitle || dbTitles[0]
        if (selectedTitle && selectedTitle.title) {
          this.adjustCharge.invoiceTitle = selectedTitle.title
        }
      } else {
        // 如果没有开票抬头数据，清空当前值
        this.adjustCharge.invoiceTitle = ''
        this.invoiceTitleList = []
      }
    },
    getRateDate() {
      if (this.selectedJobs && this.selectedJobs.length > 0) {
        // 列表取当前日期
        return new Date()
      }
      if (this.editMode === 'add' || this.editMode === 'edit') {
        return this.job.businessDate
      }
      return new Date()
    },
    async saveEvent() {
      if (!await this.validateCharge()) return
      //
      const adjustCharge = this.adjustCharge
      this.$logger.log('saveEvent-adjustCharge', adjustCharge)
      const item = null // 改单增加调整
      // 特殊费用调整保存
      const result = []
      if (this.editMode === 'add' || this.editMode === 'addSpecialUpdate') {
        if (this.selectedJobs && this.selectedJobs.length > 0) {
          for (const job of this.selectedJobs) {
            result.push(await this.createCharge(job, adjustCharge))
          }
        } else {
          result.push(await this.createCharge(this.job, adjustCharge))
        }
      } else {
        this.charge.branchId = Number(adjustCharge.branchId) // 所属分公司
        this.charge.accountId = adjustCharge.accountId
        this.charge.oversea = adjustCharge.oversea
        this.charge.receivable = false // 商务特殊费用仅应付
        this.charge.chargeItemId = adjustCharge.chargeItemId
        this.charge.currency = adjustCharge.currency
        this.charge.measure = adjustCharge.measure
        this.charge.quantity = parseFloat(adjustCharge.quantity)
        this.charge.unitRate = parseFloat(adjustCharge.unitRate)
        this.charge.taxRate = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxRate))
        this.charge.amount = ChargeUtils.getRoundingValue(Number(adjustCharge.amount))
        this.charge.taxAmount = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxAmount))
        this.charge.excludingTaxAmount = this.needInvoiceNo ? item.amount : ChargeUtils.getRoundingValue(Number(adjustCharge.excludingTaxAmount))
        this.charge.verifiedAmount = 0
        if (this.needInvoiceNo) {
          this.charge.invoiceNo = adjustCharge.invoiceNo
        }
        this.charge.needInvoice = adjustCharge.needInvoice
        this.charge.controlled = adjustCharge.controlled
        const localCurrency = RateUtil.localCurrencyByOfficeId(this.charge.branchId)
        if (this.isAdjust) { this.charge.exchangeRate = isNaN(Number(adjustCharge.exchangeRate)) ? 0 : Number(adjustCharge.exchangeRate) } else { this.charge.exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.charge.currency, this.getRateDate(), this.charge.branchId) }
        this.charge.contactPerson = adjustCharge.contactPerson
        this.charge.remarks = adjustCharge.remarks
        this.charge.invoiceTitle = adjustCharge.invoiceTitle
        if (adjustCharge.specialInputDate) {
          this.charge.specialInputDate = adjustCharge.specialInputDate
        }

        result.push(this.charge)
      }

      this.$logger.log('saveEvent-result', result)
      this.loading = getLoading()
      await saveAdjustJob(result, { editMode: this.editMode, location: this.location }).then(res => {
        if (res.data) {
          this.$emit('returnCall', res.data)
          this.close()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    async createCharge(job, adjustCharge) {
      const item = new Charge().fillDefaultValue().getData()
      item.jobUuid = job.uuid
      item.businessDate = job.businessDate
      item.inputBy = this.userId
      item.inputDate = new Date()
      item.inputByDep = this.departmentId
      item.branchId = Number(adjustCharge.branchId) // 所属分公司
      item.accountId = Number(adjustCharge.accountId)
      item.oversea = adjustCharge.oversea
      item.receivable = this.isAr
      item.chargeItemId = adjustCharge.chargeItemId
      item.currency = adjustCharge.currency
      item.verifiedAmount = 0
      const localCurrency = RateUtil.localCurrencyByOfficeId(item.branchId)
      item.localCurrency = localCurrency
      if (this.isAdjust) {
        item.exchangeRate = isNaN(adjustCharge.exchangeRate) ? 0 : Number(adjustCharge.exchangeRate)
      } else {
        item.exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, item.currency, this.getRateDate(), item.branchId)
      }
      item.inputBy = this.userId
      item.advance = this.charge.advance// 是否调整
      item.adjustment = false // 是否调整
      item.special = false // 是否特殊
      item.businessSpecial = true // 是否商务特殊费用
      item.receivable = false // 商务特殊费用仅应付
      item.measure = adjustCharge.measure
      item.quantity = parseFloat(adjustCharge.quantity)
      item.unitRate = parseFloat(adjustCharge.unitRate)
      item.taxRate = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxRate))
      item.amount = ChargeUtils.getRoundingValue(Number(adjustCharge.amount))
      item.taxAmount = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxAmount))
      item.excludingTaxAmount = this.needInvoiceNo ? item.amount : ChargeUtils.getRoundingValue(Number(adjustCharge.excludingTaxAmount))
      item.offsetState = 0
      if (this.editMode === 'addSpecialUpdate') {
        item.chargeState = 2
        item.adjustment = true
        item.accountingDate = adjustCharge.specialInputDate
        item.auditor = this.userId
      } else {
        item.chargeState = 0
      }
      item.confirmState = this.charge.confirmState
      if (this.needInvoiceNo) {
        item.invoiceNo = adjustCharge.invoiceNo
      }
      item.contactPerson = adjustCharge.contactPerson
      item.remarks = adjustCharge.remarks
      item.needInvoice = adjustCharge.needInvoice
      item.controlled = adjustCharge.controlled
      item.invoiceTitle = adjustCharge.invoiceTitle
      // 后端会进行赋值
      // // CARGO-7916 更新费用序号
      // item.serialNumber = this.refreshSerialNumber(this.isAr, job.charges)
      if (adjustCharge.specialInputDate) {
        item.specialInputDate = adjustCharge.specialInputDate
      }
      return item
    },
    refreshSerialNumber(isAr, charges) {
      let number = 0
      if (!charges) return number
      for (const c of charges) {
        if (c.receivable === isAr) {
          number++
        }
      }
      return number
    },
    // 费用所属分公司
    onChangeBranchIdHandler(result) {
      this.$logger.log('分公司', result)
      const currentOffice = result
      if (currentOffice) {
        this.adjustCharge.branchId = currentOffice.officeId
        // BUG-0013 不再写入跨页全局 localStorage：手选分公司仅对本次弹窗生效，避免污染后续新增特殊费用的默认归属
        // 结算单位（当前分公司的）
        this.adjustCharge.accountId = 0
        this.contactArray = []
        if (!this.isAr && !this.charge.advance) {
          this.charge.taxRate = ChargeUtils.getChargeRate(this.adjustCharge.accountId)
          this.excludingTaxAmountChangeHandler()
        }
      }
    },
    // 费用单位改变
    async onChangeCompany(result) {
      this.$logger.log('费用项目', result)
      if (result) {
        const chargeItem = result
        this.adjustCharge.chargeItemId = Number(chargeItem.itemId)
        // 币种优先取收费项目(DMN_CHARGE_ITEM)维护的默认应付币种——商务特殊费用为应付侧费用；未维护时兜底 RMB（否则币种被清空、汇率取不到变 0，保存被「汇率不能为0」卡住）
        this.adjustCharge.currency = chargeItem.defaultapcurrency || RateUtil.STANDARD_COIN
        await this.textCurrencyChangeHandler(null)
        await this.refreshQuantity()

        // CARGO-31015 录入或修改费用名称，不论费用名称在收费项目维护的税率是否为0，都以费用名称的税率更新此条费用的税率，0税率的税率也为0（以费用名称税率为准）
        this.adjustCharge.taxRate = chargeItem.taxRate || 0
        // CARGO-31003 在新增费用时，直接对特定的费用进行受控
        this.adjustCharge.controlled = chargeItem?.controlled
        this.adjustCharge.needInvoice = chargeItem?.needInvoice
        this.excludingTaxAmountChangeHandler()
      }
    },
    getChargeItemFilter() {
      const filter = {}
      if (this.isAr) {
        if (!this.privilege.isControlled) {
          filter.controlled = false
        }
      } else {
        if (!this.privilege.isCostControlled) {
          filter.controlled = false
        }
      }
      if (this.isSpecialExpenseEntryFunction) {
        // 商务特殊费用：仅显示勾选了「商务特殊费用标识」的收费项目
        filter.businessSpecialMarker = true
      }
      return filter
    },
    // 修改费用项时，刷新数量
    async refreshQuantity() {
      // 操作 批量业务时，不带出数量
      if (this.selectedJobs && this.selectedJobs.length > 0) {
        return
      }
      const measure = this.adjustCharge.measure
      let quantity = this.adjustCharge.quantity
      if (measure === ChargeMeasure.WGT_CHARGE_MEASURE.code) {
        if (this.job.lob === 'AE') {
          quantity = this.job.weightActual
        } else {
          const weight = this.chargeWeightValueType === 0 ? this.job.weightActual : this.job.weightContract
          quantity = weight / 1000
          if (quantity < 1) quantity = 1
        }
      } else if (measure === ChargeMeasure.WGTT_CHARGE_MEASURE.code) {
        if (this.job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === this.job.typeHBL) {
          const hbl2 = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
          if (hbl2 && hbl2.weight) {
            quantity = hbl2.weight / 1000
          }
        } else if (this.job.lob === 'AE') {
          quantity = this.job.weightActual / 1000
        } else {
          const weight = this.chargeWeightValueType === 0 ? this.job.weightActual : this.job.weightContract
          quantity = weight / 1000
          if (quantity < 1) quantity = 1
        }
      } else if (measure === 'WGTX') {
        if (this.job.lob === 'AE') {
          if (this.adjustCharge.receivable) {
            quantity = this.job.cWeight
          } else {
            const mawb = await this.job.getCargoDocByDocType(CargoDocConsts.MAWB)
            quantity = !mawb ? 0 : mawb.cWeight
          }
        } else {
          quantity = this.job.chargeWeight
        }
      } else if (measure === 'VOL') {
        quantity = this.job.cubageActual
      } else if (measure === 'MIN') {
        quantity = 1
      } else if (measure === 'NML') {
        quantity = 1
      } else {
        quantity = this.getEQQuantity(measure)
      }
      quantity = await ChargeUtils.getQuantityByChargeWeightValueType2(this.job, quantity, measure)
      this.adjustCharge.measure = measure
      this.adjustCharge.quantity = Number(quantity.toFixed(3))
    },
    // 修改费用项时，获取数量
    getEQQuantity(type) {
      let n = 0
      if (this.job.seaEQ) {
        for (const eq of this.job.seaEQ) {
          if (type === 'C20') {
            if (eq.eqSize === '20') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C40') {
            if (eq.eqSize === '40' && eq.eqType !== 'HQ') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C40H') {
            if (eq.eqSize === '40' && eq.eqType === 'HQ') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C45') {
            if (eq.eqSize === '45') {
              n = n + eq.eqQuantity
            }
          }
        }
      }
      return n === 0 ? 1 : n
    },
    // 单位
    async combMeasureChangeHandler(result) {
      this.$logger.log('单位', result)
      if (result) {
        this.adjustCharge.measure = result.code
      }
      await this.refreshQuantity()
      this.txtQuantityChangeHandler()
    },
    // 结算对象枚举同普通应付费用新增：启用公司中仅供应商可选；cmpIdx 精确匹配放行（回显已选值）
    apAccountFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      if (item.ifSupplier) {
        return true
      }
      return false
    },
    // 修改结算对象时，调整税率
    async textAccountCode_changeHandler(result) {
      this.$logger.log('结算对象', result)
      if (result) {
        const accountId = result.cmpIdx
        this.loadContacts(accountId) // 重新加载联系人
        this.adjustCharge.accountId = accountId

        // CARGO-31015 录入或修改费用名称，不论费用名称在收费项目维护的税率是否为0，都以费用名称的税率更新此条费用的税率，0税率的税率也为0（以费用名称税率为准）
        ChargeUtils.changeChargeRateByAccountId(this.adjustCharge)
        this.excludingTaxAmountChangeHandler()
        // 获取开票抬头列表并设置默认值
        await this.loadInvoiceTitle(accountId)
        this.adjustCharge.oversea = (result.designationAgent || result.overseaAgent)
      }
    },
    // 数量
    txtQuantityChangeHandler() {
      const quantity = parseFloat(this.adjustCharge.quantity)
      if (!isNaN(quantity)) {
        this.adjustCharge.quantity = quantity
        ChargeUtils.calculateTax(this.adjustCharge, this.adjustCharge.quantity * this.adjustCharge.unitRate, this.adjustCharge.taxRate, true)
      }
      this.adjustCharge.amount = this.adjustCharge.amount.toFixed(2)
    },
    // 单价
    txtUnitRateChangeHandler(result) {
      this.$logger.log('单价', result)
      const unitRate = parseFloat(ChargeUtils.ToFixed(parseFloat(result), 3))
      if (!isNaN(unitRate)) {
        this.adjustCharge.unitRate = unitRate
        this.$logger.log('this.adjustCharge.unitRate * this.adjustCharge.quantity', this.adjustCharge.unitRate * this.adjustCharge.quantity)
        this.$logger.log('this.adjustCharge.taxRate', this.adjustCharge.taxRate)
        ChargeUtils.calculateTax(this.adjustCharge, this.adjustCharge.unitRate * this.adjustCharge.quantity, this.adjustCharge.taxRate)
      }
      if (this.adjustCharge) {
        this.adjustCharge.amount = this.adjustCharge.amount.toFixed(3)
      }
    },
    // 修改含税价
    textAmountChangeHandler(result) {
      this.$logger.log('含税价', result)
      const amount = parseFloat(ChargeUtils.ToFixed(parseFloat(result), 2))
      if (!isNaN(amount)) {
        this.adjustCharge.amount = amount
        ChargeUtils.calculateTaxAmount(this.adjustCharge, amount, this.adjustCharge.taxRate)
      }
      if (this.adjustCharge) {
        this.adjustCharge.unitRate = this.adjustCharge.unitRate.toFixed(2)
      }
    },
    // 修改不含税金额
    excludingTaxAmountChangeHandler() {
      if (this.charge.advance) return
      if (!isNaN(this.adjustCharge.excludingTaxAmount)) {
        ChargeUtils.calculateTax(this.adjustCharge, this.adjustCharge.excludingTaxAmount, this.adjustCharge.taxRate, true)
      }
    },
    // 税率
    txtRateChangeHandler() {
      if (this.charge.advance) return
      if (isNaN(this.adjustCharge.taxRate)) {
        this.adjustCharge.taxRate = 0.0
      }
      ChargeUtils.calculateTax(this.adjustCharge, this.adjustCharge.excludingTaxAmount, this.adjustCharge.taxRate, true)
    },
    async textCurrencyChangeHandler(result) {
      this.$logger.log('币种', result)
      if (this.isAdjust) {
        if (result) {
          this.adjustCharge.currency = result.code
        }
        this.businessDate = new Date(this.adjustCharge.auditDate)
        if (this.editMode !== 'addSpecialUpdate') {
          // CARGO-23919 淳宏供应链：新增特殊费用为外币时，汇率是按照创建日期获取
          this.businessDate = this.getRateDate()
        } else if (this.editMode === 'addSpecialUpdate') {
          this.businessDate = new Date(this.adjustCharge.specialInputDate)
        }
        this.selCurrency = this.adjustCharge.currency
        const localCurrency = RateUtil.localCurrencyByOfficeId(this.adjustCharge.branchId)
        const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.adjustCharge.currency, this.businessDate, this.adjustCharge.branchId)
        this.adjustCharge.exchangeRate = isNaN(exchangeRate) ? '0' : exchangeRate.toString()
      }
    },
    async textDateChangeHandler() {
      if (this.isAdjust) {
        this.businessDate = new Date(this.adjustCharge.auditDate)
        if (this.editMode !== 'addSpecialUpdate') {
          this.businessDate = new Date(this.adjustCharge.dateCreated)
        } else if (this.editMode === 'addSpecialUpdate') {
          this.businessDate = new Date(this.adjustCharge.specialInputDate)
        }
        this.pageDate = this.businessDate
        const localCurrency = RateUtil.localCurrencyByOfficeId(this.adjustCharge.branchId)
        const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.adjustCharge.currency, this.businessDate, this.adjustCharge.branchId)
        this.adjustCharge.exchangeRate = isNaN(exchangeRate) ? '0' : exchangeRate.toString()
      }
    },
    async auditDateChangeHandler() {
      if (this.isAdjust) {
        const localCurrency = RateUtil.localCurrencyByOfficeId(this.adjustCharge.branchId)
        const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.adjustCharge.currency, this.adjustCharge.auditDate, this.adjustCharge.branchId)
        this.adjustCharge.exchangeRate = isNaN(exchangeRate) ? '0' : exchangeRate.toString()
      }
    },
    // 加载结算对象所维护的联系人
    loadContacts(chargeAccountId) {
      getContacts({ cmpIdx: chargeAccountId }).then(res => {
        if (res.data) {
          this.contactArray = res.data
        }
      }).catch(error => {
        console.log('getContacts error', error)
      })
    },
    // 保存费用校验
    async validateCharge() {
      // Prevent from processing twice
      const job = new Job(this.job)
      if (job && job.charges && job.charges.length > 0) {
        for (const c of job.charges) {
          if (!c.uuid) return false
        }
      }
      const adjustCharge = this.adjustCharge
      if (isNaN(adjustCharge['accountId']) || Number(adjustCharge['accountId']) <= 0) {
        this.$message.warning(this.$t('Message.SettlementPartyCannotBeNull'))
        return false
      }
      if (isNaN(adjustCharge['chargeItemId']) || Number(adjustCharge['chargeItemId']) <= 0) {
        this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
        return false
      }
      if (isNaN(adjustCharge['quantity']) || Number(adjustCharge['quantity']) === 0) {
        this.$message.warning(this.$t('Message.AmountCannotBeZero'))
        return false
      }
      if (isNaN(adjustCharge['exchangeRate']) || adjustCharge['exchangeRate'] === 0) {
        this.$message.warning(this.$t('Message.ExchangeCannotBeZero2'))
        return false
      }
      if (adjustCharge['remarks'] && adjustCharge['remarks'].length > 50) {
        this.$message.warning(this.$t('Message.RemarkTheLengthCannotExceed'))
        return false
      }
      if (this.needInvoiceNo) {
        if (!adjustCharge['invoiceNo']) {
          this.$message.warning(this.$t('Message.InvoiceNoCannotBeNull'))
          return false
        }
        if (adjustCharge['invoiceNo'].length > 32) {
          this.$message.warning(this.$t('Message.InvoiceNoIsTooLong'))
          return false
        }
      }
      if (adjustCharge['chargeItemId']) {
        const message = ChargeUtils.checkChargeRateRange(adjustCharge)
        if (message) {
          this.$message.warning(this.$t('CargoMsg.Cargo_TaxRateRangeLimit', [message]))
          return
        }
      }
      if (!await ChargeUtils.checkUnitRate([adjustCharge], this)) {
        return false
      }
      return true
    },
    // 关闭时清空值
    clearInput() {
      this.selCurrency = ''
      this.editMode = null
      this.isAdjust = true // 是否调整
      this.isAdvance = false
      this.needMakeInvoice = false
      this.isAr = false
      this.job = null
      this.selectedJobs = []
      this.charge = null
      this.needInvoiceNo = false
      const adjustCharge = this.adjustCharge
      adjustCharge['accountId'] = ''
      adjustCharge['contactPerson'] = ''
      adjustCharge['currency'] = ''
      adjustCharge['quantity'] = 1.000
      adjustCharge['unitRate'] = 1.00
      adjustCharge['invoiceNo'] = ''
      adjustCharge['chargeItemId'] = ''
      adjustCharge['excludingTaxAmount'] = 0.00
      adjustCharge['amount'] = 0.00
      adjustCharge['taxRate'] = 0.00
      adjustCharge['taxAmount'] = 0.00
      adjustCharge['remarks'] = ''
      adjustCharge['auditDate'] = this.pageDate
      this.adjustCharge = {}
    },
    cancel() {
      this.$confirm(this.$t('Message.CancelMotify'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.close()
      }).catch(() => {
      })
    },
    close() {
      this.clearInput()
      this.innerVisible = false
    },
    onChangeIsOverseaHandler(item) {
      this.$logger.log(this.$t('SeaExport.Oversea'), item)
      if (item) {
        this.adjustCharge.oversea = item.value
        LocalStorageUtils.setConfiguration('specialChangeIsOversea', item.value)
      }
    }
  }
}
</script>
<style lang="scss">
  .special-charge-window {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>

